import React from 'react';

import { DatePicker, Form, Modal } from 'antd';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { useNotification } from 'segments/hooks';
import i18n from 'segments/i18n';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { useCreateUserMutation } from 'features/users';

interface FormData {
  name: string;
  password?: string;
  email?: string;
  note?: string;
  phone?: string;
  birthDate?: Dayjs;
}

interface Props {
  handleCancel: () => void;
}

export const CreateUserModal = ({ handleCancel }: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'user' });

  const [form] = Form.useForm<FormData>();

  const [createUser, { isSuccess, isError, isLoading, error }] = useCreateUserMutation();

  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  const onFinish = ({ birthDate, ...values }: FormData) => {
    createUser({
      birthDate: birthDate?.format('YYYY-MM-DD'),
      ...values
    });
  };

  return (
    <Modal
      title={t('create-user')}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        <InputStr type="name"
          formProps={{ rules: [{ required: true }] }}
        />
        <InputStr type="password" />
        <InputStr type="email" />
        <InputStr type="phone" />
        <InputStr type="note" />
        <Form.Item
          label={i18n.t('table.birth-date')}
          name='birthDate'
        >
          <DatePicker />
        </Form.Item>
        <SubmiteButton submiteText={i18n.t('submite')} isLoading={isLoading} />
      </Form>
    </Modal>
  );
};
